<p-dialog [header]="'Asistencia'"
    [modal]="true"
    [(visible)]="showModal"
></p-dialog>
<div class="layout-menu">
    <ng-container >
        <ul>
            @for(item of model; track $index){

            <li
                app-menuitem
                *ngIf="!item.separator"
                [item]="item"
                [index]="$index"
                [root]="true"
            ></li>
            }
        </ul>
    </ng-container>
    <div class="sublist">
            <!-- <button class="help-btn" (click)="openModal()">
                <i class="pi pi-question-circle"></i>
            <span>
                Necesito ayuda
            </span>
            </button> -->
        <div class="menu-bbva-banner">
           <img src="./assets/bbva-seguros-logo-negativo.png" alt="BBVA Seguros" class="menu-bbva-banner__logo">
        </div>
    </div>
</div>
